export const TRANSITION_TIME = 200;
